export const apiCanonicalUrl = '/api/canonical_url.json';
export const apiSeoContent = '/api/seo_content.json';
